import {
  createDefaultDebugDefaults,
  migrateDebugDefaults,
  type DebugDefaultsDocument,
} from '../sim/debugDefaults/index.ts';
import { fetchPlayDebugDefaultsFromRepo } from '../ui/play/debugDefaultsStore.ts';

const modules = import.meta.glob('../sim/debugDefaults/defaults.json', {
  eager: true,
  import: 'default',
}) as Record<string, unknown>;

/** Last disk/save snapshot in this page. Vite ignores the JSON so a save must not remount. */
let live: DebugDefaultsDocument | null = null;

/** Shipped play-debug knobs, or the TypeScript factory if the JSON is missing or corrupt. */
export function loadPlayDebugDefaults(): DebugDefaultsDocument {
  if (live) {
    return live;
  }

  const raw = Object.values(modules)[0];

  return migrateDebugDefaults(raw) ?? createDefaultDebugDefaults();
}

export function rememberPlayDebugDefaults(document: DebugDefaultsDocument): void {
  live = document;
}

/** DEV: read defaults.json from disk. Preview uses the bundled file only. */
export async function hydratePlayDebugDefaultsFromRepo(): Promise<DebugDefaultsDocument | null> {
  const document = await fetchPlayDebugDefaultsFromRepo();

  if (document) {
    rememberPlayDebugDefaults(document);
  }

  return document;
}
